var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":_vm.width,"height":_vm.height,"fill":_vm.color,"viewBox":"0 0 16 16"}},[_c('path',{attrs:{"fill-rule":"gray","clip-rule":"evenodd","d":"M8.024 5.928l-4.357 4.357-.62-.618L7.716 5h.618L13 9.667l-.619.618-4.357-4.357z","fill":_vm.color}})])
}
var staticRenderFns = []

export { render, staticRenderFns }